import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  type ReactNode,
} from "react";

const RouteIdentityContext = createContext<
  ((identity: string | undefined) => void) | undefined
>(undefined);

export function RouteIdentityProvider({
  onIdentityChange,
  children,
}: {
  onIdentityChange: (identity: string | undefined) => void;
  children: ReactNode;
}) {
  const value = useMemo(() => onIdentityChange, [onIdentityChange]);
  return (
    <RouteIdentityContext.Provider value={value}>
      {children}
    </RouteIdentityContext.Provider>
  );
}

/** Lets a route contribute a dynamic breadcrumb label, e.g. the workflow being edited. */
export function useRouteIdentity(identity: string | undefined): void {
  const setIdentity = useContext(RouteIdentityContext);
  useEffect(() => {
    setIdentity?.(identity);
    return () => setIdentity?.(undefined);
  }, [setIdentity, identity]);
}
